export {
  default as MessageDivider,
  type MessageDividerProps,
} from './MessageDivider';
